var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBoxCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 389,
    viewBox: "0 0 389 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.317 209.016L179.937 252.635L252.635 150.857M368.952 194.476C368.952 217.389 364.44 240.077 355.671 261.245C346.903 282.414 334.051 301.648 317.85 317.85C301.648 334.051 282.414 346.903 261.245 355.671C240.077 364.44 217.389 368.952 194.476 368.952C171.564 368.952 148.876 364.44 127.707 355.671C106.539 346.903 87.3045 334.051 71.1029 317.85C54.9013 301.648 42.0495 282.414 33.2812 261.245C24.513 240.077 20 217.389 20 194.476C20 148.202 38.3823 103.824 71.1029 71.1029C103.824 38.3823 148.202 20 194.476 20C240.75 20 285.129 38.3823 317.85 71.1029C350.57 103.824 368.952 148.202 368.952 194.476Z",
    stroke: "#0082FC",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBoxCheckIcon);
export default __webpack_public_path__ + "static/media/circle-box-check-icon.68e20cb2fc94347864b3c8e03d4eebbb.svg";
export { ForwardRef as ReactComponent };